import { useMemo } from 'react';
import { Field, Dropdown, FieldTypes, useFormState } from '@carboledger/ui';
import { MAX_ALLOCATION_PREFERENCES, buildAllocationFieldOptions } from '@/config/formOptions';
import { allocationPreferenceRule } from '@/lib/validation';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options   allocation-preference options; the slice decides whether Single counting is in
 *   disabled  locks the control
 */
export const AllocationPreferenceField = ({ options = EMPTY_LIST, disabled = false }) => {
  const t = useTranslations();
  const { values } = useFormState();
  const selected = values.allocationPreference;

  const fieldOptions = useMemo(
    () => buildAllocationFieldOptions(options, selected),
    [options, selected],
  );

  return (
    <Field name="allocationPreference" type={FieldTypes.multi} rules={allocationPreferenceRule}>
      {({ id, name, value, onChange, status, message, required }) => (
        <Dropdown
          multiple
          id={id}
          name={name}
          label={t('FORM_ALLOCATION_PREFERENCE')}
          placeholder={t('COMMON_SELECT')}
          value={value}
          onChange={onChange}
          status={status}
          // Falls back to the cap hint, which is why every form must not spell it itself.
          message={message ?? t('COMMON_ALLOCATION_HINT', { max: MAX_ALLOCATION_PREFERENCES })}
          required={required}
          disabled={disabled}
          options={fieldOptions}
        />
      )}
    </Field>
  );
};
